import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { isNullOrUndefined } from 'util';

import { BroadcastChannelService, ByChannel } from './broadcast-channel.service';

interface PingPongData {
	event: 'ping' | 'pong';
	timestamp: number;
}

const channelName: string = 'tabcount';

@Injectable()
export class TabCountService {
	private _pings: { [s: number]: number } = {};
	private _channel;

	public constructor(private _bc: BroadcastChannelService) {}

	public init() {
		this._channel = this._bc.create(channelName);

		this._bc.messages$.filter(ByChannel(channelName)).map(e => e.data).subscribe(e => {
			this._onPing(e);
		});
	}

	public getTabCount(pingTimeout: number = 500): Observable<number> {
		return Observable.create(obs => {
			if (!this._channel) {
				obs.next(1);
				return;
			}

			const timestamp = (new Date()).getTime();
			this._pings[timestamp] = 1;
			this._channel.postMessage({event: 'ping', timestamp: timestamp});

			setTimeout(() => {
				const count = this._pings[timestamp];
				delete this._pings[timestamp];
				obs.next(count);
			}, pingTimeout);
		});
	}

	private _onPing(e: PingPongData) {
		switch (e.event) {
			case 'ping':
				this._channel.postMessage({event: 'pong', timestamp: e.timestamp});
				break;

			case 'pong':
				if (!isNullOrUndefined(this._pings[e.timestamp])) {
					this._pings[e.timestamp]++;
				}
				break;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/broadcast-channel/tab-count.service.ts